import request from '@/utils/request';

export function handleListApi(data) {
  return request({
    url: '/admin/blocklist',
    method: 'get',
    params: data
  });
}

export function handleCreateStoreApi(data) {
  return request({
    url: '/admin/blocklist',
    method: 'post',
    data
  });
}

export function handleDeleteApi(id) {
  return request({
    url: '/admin/blocklist/' + id,
    method: 'delete'
  });
}
